import { render, staticRenderFns } from "./menu-footer.vue?vue&type=template&id=f5629f64&scoped=true"
import script from "./menu-footer.vue?vue&type=script&lang=js"
export * from "./menu-footer.vue?vue&type=script&lang=js"
import style0 from "./menu-footer.vue?vue&type=style&index=0&id=f5629f64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5629f64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5629f64')) {
      api.createRecord('f5629f64', component.options)
    } else {
      api.reload('f5629f64', component.options)
    }
    module.hot.accept("./menu-footer.vue?vue&type=template&id=f5629f64&scoped=true", function () {
      api.rerender('f5629f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/menu-footer.vue"
export default component.exports